import styled from 'styled-components';

import { TextButton as InnerTextButton } from '@xing-com/button';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';
import {
  scale120,
  spaceL,
  spaceS,
  spaceXL,
  xdlColorText,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { Meta as InnerMeta } from '@xing-com/typography';

export const TextButton = styled(InnerTextButton)<{
  $isLast?: boolean;
  $fontSize: number;
}>`
  height: ${scale120};
  font-weight: 400;
  font-size: ${({ $fontSize }) => $fontSize}px;
  &:visited {
    color: ${({ $isLast }) => ($isLast ? xdlColorText : xdlColorTextSecondary)};
  }
  pointer-events: ${({ $isLast }) => ($isLast ? 'none' : 'auto')};
  text-decoration: ${({ $isLast }) => ($isLast ? 'none' : 'underline')};
`;

export const Separator = styled(InnerMeta)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 ${spaceS};
  padding: 0;
`;

export const SeoBreadcrumbNav = styled.nav`
  display: flex;
  margin: ${spaceL} 0 ${spaceXL} 0;
`;

export const SeoBreadcrumbList = styled.ol`
  display: flex;
  margin: 0;
  padding: 0;
  & > * {
    flex: 0 0 auto;
  }

  @media ${mediaTopBarVisible} {
    overflow: auto;
    padding-block: ${spaceL};
  }

  @media ${mediaTopBarHidden} {
    flex-wrap: wrap;
  }
`;

export const SeoBreadcrumbListItem = styled.li`
  display: flex;
  text-decoration: none;
  list-style: none;
`;

export const TruncatedWrapper = styled.span`
  min-width: 0;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
